<template>
  <div class="content-wrapper">
    <!-- Aside Bar -->
    <AsideBar />
    <!-- Content Header -->
    <section class="content-header">
      <div style="border-bottom: 1px solid #00000017; height: 75px">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 v-if="this.$route.path.includes('audience')">
              Audience: {{ $route.params.seg_id }}
            </h1>
            <h1 v-else>Segment: {{ $route.params.seg_id }}</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <!-- Breadcrumb For Audience -->
              <router-link
                tag="li"
                class="breadcrumb-item"
                v-if="this.$route.path.includes('audience')"
                :to="{ name: 'Audience Creator' }"
                >Audience Creator</router-link
              >
              <!-- Breadcrumb For Segmentation -->
              <router-link
                tag="li"
                class="breadcrumb-item"
                v-else
                :to="{ name: 'Manual Segmentation' }"
                >Segmentation</router-link
              >
              <!-- Breadcrumb For Audience -->
              <li
                v-if="this.$route.path.includes('audience')"
                class="breadcrumb-item active"
              >
                Audience Creator: {{ $route.params.seg_id }}
              </li>
              <!-- Breadcrumb For Segments -->
              <li v-else class="breadcrumb-item active">
                Segment: {{ $route.params.seg_id }}
              </li>
            </ol>
          </div>
          <div class="col-sm-6 d-flex justify-content-end align-items-center">
            <v-btn
              style="height: 34px !important"
              small
              color="primary"
              class="m-0 mr-3 width-fit-content"
              :disabled="fileInProgress"
              :loading="fileLoading"
              @click="exportXLSXFile"
            >
              Upload as XLSX
            </v-btn>
            <router-link
              :to="
                this.$route.path.includes('audience')
                  ? { name: 'Audience Creator' }
                  : { name: 'Manual Segmentation' }
              "
              class="m-0"
            >
              <v-btn dark color="primary" style="height: 34px !important">
                {{
                  this.$route.path.includes("audience")
                    ? "All Audience"
                    : "All Segments"
                }}
              </v-btn>
            </router-link>
          </div>
        </div>
      </div>
      <!-- Table For Audience -->
      <v-card class="m-4">
        <v-data-table
          :headers="headers"
          :items="items.data"
          class="elevation-1"
          :loading="loading"
          :server-items-length="totalLength"
          :options.sync="options"
          :footer-props="{
            'items-per-page-options': [10, 25, 50],
            class: 'td--visualize-sticky',
          }"
          loading-text="Loading ..."
          style="overflow-x: scroll !important"
        >
          <template v-slot:[`item.website_id`]="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <span
                  class="text-transform--ellipsis width-280 c-pointer"
                  @click="copyToClipboard(item.website_id)"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.website_id }}
                </span>
              </template>
              <span>Click To Copy</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.subscription_url`]="{ item }">
            <v-edit-dialog :return-value.sync="item.subscription_url">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="visualize-audience-link"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.subscription_url }}
                  </span>
                </template>
                <span>Click To Reveal</span>
              </v-tooltip>
              <template v-slot:input>
                <v-text-field
                  v-model="item.subscription_url"
                  label="Edit"
                  color="#2196f3"
                  single-line
                  counter
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:[`item.last_url_visited`]="{ item }">
            <v-edit-dialog :return-value.sync="item.last_url_visited">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="visualize-audience-link"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.last_url_visited }}
                  </span>
                </template>
                <span>Click To Reveal</span>
              </v-tooltip>
              <template v-slot:input>
                <v-text-field
                  v-model="item.last_url_visited"
                  label="Edit"
                  color="#2196f3"
                  single-line
                  counter
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
        </v-data-table>
      </v-card>
    </section>
    <!-- Error -->
    <Error v-if="error" :error="error" />
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        :message="failureText"
        @update-failure="handleUpdateToFailureSnackbar"
      />
    </transition>
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        :message="successText"
        @update-success="handleUpdateToSuccessSnackbar"
      />
    </transition>
    <!-- <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Files v-if="shwFilePopUp" @didClose="shwFilePopUp = false" />
    </transition> -->
  </div>
</template>

<script>
import Error from "../popUps/Error.vue";
import Segments from "../../apis/Segments.js";
import Domain from "../../apis/Domains.js";
import { mapState, mapActions } from "vuex";
import Spinner from "../popUps/Spinner.vue";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";

import common from "../../mixins/common";

export default {
  name: "MoreInfoSubs",
  mixins: [common],
  components: {
    AsideBar: () => import("../websiteDash/AsideBar.vue"),
    Error,
    Spinner,
    FailureSnackbar,
    SuccessSnackbar,
  },
  data() {
    return {
      shwCopyBtn: false,
      shwFilePopUp: false,
      failure: false,
      failureText: "Error",
      success: false,
      successText: "Successfully!",
      fileLoading: false,
      subsListToExport: [],
      offsetAud: 0,
      offsetSegm: 0,
      selected: "Title",
      shwOpt1: true,
      type: this.$route.params.type,
      obj: this.$route.params.obj,
      items: [],
      loading: true,
      options: {},
      page: null,
      itemsPerPage: null,
      totalLength: null,
      website_id: null,
      filters: [],
      array: [
        {
          filters: [],
        },
      ],
      headers: [
        {
          text: "Id",
          value: "id",
          class:
            "th--visualize-sticky pr-5 table-header--color-grey border-right",
          cellClass: "td--visualize-sticky pr-5 border-right",
          divider: true,
        },
        {
          text: "Subscribable Id",
          value: "subscribable_id",
          class:
            "th--visualize-sticky left-72 pr-5 table-header--color-grey border-right",
          cellClass: "td--visualize-sticky left-72 pr-5 border-right",
          divider: true,
        },
        {
          text: "Device",
          value: "device",
          class:
            "th--visualize-sticky left-174 pr-5 table-header--color-grey border-right",
          cellClass: "td--visualize-sticky left-174 pr-5 border-right",
          divider: true,
          sortable: false,
        },
        {
          text: "Website Id",
          value: "website_id",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "OS",
          value: "os",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "Browser",
          value: "browser",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "Resolution",
          value: "resolution",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "Location",
          value: "location",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "Language",
          value: "language",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "Timezone",
          value: "timezone",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Subscription Url",
          value: "subscription_url",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "Last Url Visited",
          value: "last_url_visited",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "Last Drip Number",
          value: "last_drip_number",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
        {
          text: "IP",
          value: "ip",
          divider: true,
          class: "table-header--color",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      error: (state) => state.segment.errorSegment,
    }),
  },
  mounted() {
    Segments.get(
        `?order_by=id:desc&where[id]=${
          this.$route.params.seg_id
        }&where[domain_id]=${this.$route.params.id}&where[type]=${
          this.$route.path.includes("audience") ? "audience" : "segment"
        }`
      ).then((response) => {
        this.array[0]["filters"].push(response.data.data[0].query.filters[0]);
        this.options = {
          itemsPerPage: 10,
          page: 1,
        };
      });
  },
  methods: {
    ...mapActions(["getSegments"]),
    copyToClipboard(text) {
      this.writeTextToClipboard(text)
        .then(() => {
          this.successText = "Copied!";
          this.success = true;
        })
        .catch(() => {
          this.failure = true;
        });
    },
    obtainSubscribersData(options) {
      this.loading = true;

    //   Domain.show("/" + this.$route.params.id).then((response) => {
    //     this.website_id = response.data.data[0].website_id;
        if (this.$route.params.obj || this.array[0].filters) {
          Segments.get(
            this.$route.params.seg_id,
            10000,
            `&paginate=true&pageLength=${options.itemsPerPage}&page=${options.page}&order_by=id:desc`,
            this.$route.params.obj === undefined
              ? this.array[0]
              : this.$route.params.obj.query
          )
            .then((response) => {
              this.items = response.data.data;
              this.totalLength = response.data.data.total;
              this.itemsPerPage = options.itemsPerPage;
              this.page = options.page;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
    //   });
    },
  },
  watch: {
    "$route.name": {
      handler() {},
      deep: true,
      immediate: true,
    },
    options: {
      handler(options) {
        this.loading = true;

        this.obtainSubscribersData(options);

        queueMicrotask(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        })
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
